import PageBreadcrumb from "@/components/common/PageBreadCrumb";

export default function Home() {
  return (
    <>
      <PageBreadcrumb pageTitle="Inicio" />
      <div className="flex flex-col items-center justify-center min-h-[calc(100vh-300px)] px-4">
        <div className="max-w-2xl w-full text-center space-y-8 animate-in fade-in zoom-in duration-700">
          {/* Logo Container with a subtle glow */}
          <div className="relative inline-block group">
            <div className="absolute -inset-1 bg-gradient-to-r from-brand-500 to-brand-600 rounded-full blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200"></div>
            <img 
              src="/logo.png" 
              alt="Logo" 
              className="relative h-32 md:h-40 w-auto mx-auto object-contain drop-shadow-theme-xl transition-transform duration-500 group-hover:scale-105"
            />
          </div>

          {/* Welcome Message */}
          <div className="space-y-4">
            <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 dark:text-white tracking-tight">
              Bienvenido a la <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-500 to-brand-600">Plataforma</span>
            </h1>
            <p className="text-lg md:text-xl text-gray-600 dark:text-gray-400 max-w-lg mx-auto leading-relaxed">
              Estamos encantados de tenerte de vuelta. Gestiona tus proyectos, empresas y equipos de forma eficiente y elegante desde tu panel centralizado.
            </p>
          </div>

          {/* Decorative Divider */}
          <div className="flex items-center justify-center gap-4 pt-6">
            <div className="h-px w-16 bg-gradient-to-r from-transparent via-gray-300 to-transparent dark:via-gray-700"></div>
            <div className="flex gap-2">
              <div className="w-2 h-2 rounded-full bg-brand-500"></div>
              <div className="w-2 h-2 rounded-full bg-brand-400"></div>
              <div className="w-2 h-2 rounded-full bg-brand-300"></div>
            </div>
            <div className="h-px w-16 bg-gradient-to-r from-transparent via-gray-300 to-transparent dark:via-gray-700"></div>
          </div>
          
          <p className="text-sm font-medium uppercase tracking-widest text-gray-500 dark:text-gray-500">
            Tu centro de operaciones multifuncional
          </p>
        </div>
      </div>
    </>
  );
}
